import React, {useEffect, useState} from "react";
import TMSearchHeader from "./TMSearchHeader";
import TMSearchResults from "./TMSearchResults";
import axios from 'axios';
import {
    Chip,
    Dialog, Divider,
    LinearProgress, MenuItem, Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import TMDetailSingle from "./TMDetailSingle";

// const TRADEMARK_FETCH_URL = "http://127.0.0.1:8000"
const TRADEMARK_FETCH_URL = "https://apis.flashbit.in"
const TRADEMARK_DETAIL_FETCH_URL = "https://apis.flashbit.in/detail/"
// const TRADEMARK_DETAIL_FETCH_URL = "https://apis.flashbit.in/detail/"
const classes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45]

const limit = 20;

const TMSearch = () => {

    const [wordmark, setWordmark] = useState('');
    const [filterClass, setFilterClass] = useState(0);
    const [fetching, setFetching] = useState(false);
    const [loading, setLoading] = useState(false);

    const [trademarks, setTrademarks] = useState([])
    const [offset, setOffset] = useState(0);
    const [count, setCount] = useState(0);
    const [searchedWordmark, setSearchedWordmark] = useState('');

    const [dialog, setDialog] = useState(false);
    const [detailedTrademark, setDetailedTrademark] = useState({});

    const fetchTrademarks = (wordmark, offset = 0, class_number = null, load_more=false) => {
        const params = {
            wordmark: wordmark,
            offset: offset,
            limit:limit,
            class_number:class_number
        }

        if(load_more){
            setLoading(true)
        } else {
            setFetching(true);
        }
        axios.get(TRADEMARK_FETCH_URL, {params})
            .then(res => {
                setOffset(res.data.offset)
                setCount(res.data.count)
                load_more ? setTrademarks(trademarks.concat(res.data.dataset)) : setTrademarks(res.data.dataset)
                setSearchedWordmark(res.data.wordmark)
                setFetching(false);
                setLoading(false)
            }).catch(err => {
            setFetching(false)
            setLoading(false)
            setTrademarks([])
            setOffset(0)
            setCount(0)
        })
    }

    const handleSearch = () => {
        setTrademarks([])
        if(wordmark === ""){
            return
        }
        if (searchedWordmark !== wordmark && filterClass !== 0){
            setFilterClass(0)
        } else {
            fetchTrademarks(wordmark, 0, filterClass, false)
        }
    }

    const handleLoadMore = () => {
        fetchTrademarks(searchedWordmark, offset, null,true)
    }

    const openDetail = (trademark) => {
        setDetailedTrademark(trademark)
        setDialog(true);
    }

    useEffect(() => {
        // ON CLASS CHANGE
        handleSearch()
    }, [filterClass])


    return (
        <div className='flex flex-col'>
            <TMSearchHeader fetching={fetching}
                            wordmark={wordmark}
                            setWordmark={setWordmark}
                            onSubmit={handleSearch}/>

            <div className="sticky top-0 bg-white shadow">
                <Divider/>
                <div className='h-1'>
                    {fetching && <LinearProgress className=''/>}
                </div>
                <div className='flex flex-row px-4 py-2 pb-3'>
                    <div className='flex flex-row flex-1'>
                        <p className='pt-1'>Filter by Class</p>
                        <Select value={filterClass}
                                className='ml-4'
                                defaultValue={0}
                                onChange={(e) => setFilterClass(e.target.value)}>
                            <MenuItem key='all' value={0}>All</MenuItem>
                            {classes.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                        </Select>
                    </div>
                    <Chip style={{cursor:'pointer'}} label='Register your Trade Mark' color={"primary"} component={'a'} target={'_blank'}
                          href='/trademark-requisition-form/' className='cursor-pointer shadow-lg hover:shadow-sm'/>

                </div>
            </div>
            <div className='h-4'/>

            <TMSearchResults
                trademarks={trademarks}
                loading={loading}
                wordmark={wordmark}
                searchedWordmark={searchedWordmark}
                count={count}
                offset={offset}
                limit={limit}
                openDetail={openDetail}
                onLoadMore={handleLoadMore}
            />
            <Dialog open={dialog} onClose={() => setDialog(false)}>
                <TMDetailSingle trademark={detailedTrademark}/>
            </Dialog>
        </div>
    )
}

export default TMSearch